import React from 'react';
import Header from '../components/Header';
import TermsOfService from '../components/TermsOfService';
import Footer from '../components/Footer';

function TermsPage() {
  return (
    <>
      <Header />
      <main>
        <TermsOfService />
      </main>
      <Footer />
    </>
  );
}

export default TermsPage;
